<div [@zoomInOnEnter] class="sessionCard mat-elevation-z2" role="region">
	<div class="headerRow">
		<label class="headerLabel">{{ session().title }}</label>
		@if (showActionMenu()) {
			<sim-action-menu (onDelete)="confirmDelete()" [actions]="[{fontIcon: 'fa-edit', click: openEdit(), labelKey: T.BUTTON_EDIT}]" />
		}
	</div>
	<div class="headerRow">
		<span class="secondary">
			<mat-icon fontIcon="fa-user-friends" fontSet="fas" inline />
			{{ session().type | enumLabel: EnumLabel.SessionType }}
		</span>
		<span class="secondary">
			<mat-icon fontIcon="fa-clock" fontSet="far" inline />
			{{ session().startTime | timeRangeLabel: session().endTime ?? session().plannedEndTime }}
		</span>
		<sim-session-status-tag [status]="session().state" />
	</div>
	<section class="panels">
		@if (runs().length) {
			<div class="panel">
				<sim-session-run-preview [runs]="runs()" />
			</div>
			<div class="panel">
				<sim-session-station-preview [contentTemplate]="contentTemplate" [stations]="session().stations" />
			</div>
		} @else {
			<div class="panel emptyState secondary">
				<mat-icon fontSet="fad" fontIcon="fa-layer-minus" />
				{{ T.PEER_PRACTICE_SESSION_CARD_RUNS_EMPTY_STATE | translate }}
			</div>
		}
	</section>
	<section class="actionsFooter">
		<ng-content select="[actions]" />

		<!--ABORT-->
		@if (canCancelSession()) {
			<button mat-raised-button color="warn" (click)="cancelSession()">
				{{ T.EVENT_SESSION_EXAM_SESSION_ABORT_SESSION_BTN_TXT | translate }}
			</button>
		}

		<!--START-->
		@if (canStartSession()) {
			<div [matTooltip]="!isScheduledToday() ? (T.EVENT_SESSION_START_DISABLED_NOT_SAME_DAY | translate) : null">
				<sim-button
					(onClick)="startSession()"
					[icon]="{fontIcon: 'fa-play', fontSet: 'fad'}"
					[label]="T.EVENT_SESSION_SESSION_START_BTN_TXT"
					[disabled]="!isScheduledToday()"
					[appBusy]="busyPromise()"
					size="small"
				/>
			</div>
		}

		<!--OPEN MC-->
		@if (canOpenMcApp()) {
			<button mat-raised-button color="accent" (click)="openMcApp()">
				{{ T.EVENT_SESSION_EXAM_SESSION_OPEN_MASTER_OF_CEREMONY_APP_BTN_TXT | translate }}
			</button>
		}
	</section>
</div>

<!--CONTENT TEMPLATE-->
<ng-template #contentTemplate let-context>
	<sim-peer-practice-session-card-station-content [index]="context.index" [session]="session()" [station]="context.station" />
</ng-template>
